import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import {IDialogView} from '@shared/components/ok-cancel-dialog/ok-cancel-dialog.component';
import {DialogModel} from '@shared/models/dialog.model';

@Component({
    standalone: false,
    selector: 'particle-check-out-dialog',
  templateUrl: './check-out-dialog.component.html',
  styleUrls: ['./check-out-dialog.component.scss']
})
export class CheckOutDialogComponent implements OnInit, IDialogView {
  data: DialogModel;
  message: string;
  constructor() { }

  ngOnInit() {
  }
  onOkClicked() {
    this.data.input.message = this.message;
    return true;
  }
}
